import app from "../data/base";

async function getList() {
  try {
    const response = await app.methods.callserver('api/session', 'GET', null, null, true);
    return await response.json();
  } catch (e) {
    console.log(e);
    throw e
  }
}

export const sessions = {
  methods: {
    getList
  }
}
